import React, { Component } from 'react';
import styled from "styled-components";
// import { Link } from "react-router-dom";
// import * as ROUTES from '../../constants/routes';
import * as MDICONS from '@material-ui/icons';
import QR from "../../assets/mics/defaultQR.png";
import EditProfileForm from './EditProfileForm';
import { connect } from 'react-redux';
import { openUserUpdateModal, signOut } from '../../store/actions/authActions';
import EmptyUserDefault from '../../assets/mics/emptyUser.svg';
import Loader from 'react-loader-spinner';
import QRGenerate from '../widgets/QRGenerate';
import ReactModal from 'react-modal';
import MyPaymentSettings from '../landing/pricing/tabbedComponents/MyPaymentSettings';
import MyPlacedOrders from '../landing/pricing/tabbedComponents/MyPlacedOrders';
import MyPaymentCardDetails from '../landing/pricing/tabbedComponents/MyPaymentCardDetails';

const ProfileEditButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: #fafafa;
        margin: 2px;

        &:hover {
            color: #fafafa;
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: #fafafa;
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

const SignOutButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: transparent;
        background-color: transparent;
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.themeColor};
            text-decoration: underline;
        }

        &:active {
            color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

class MyProfile extends Component {

    constructor(props) {
        super()

        this.state = {
            showEditFormModal: false,
        }
    }

    handleSignOut = (e) => {
        e.preventDefault();
        this.props.signOut();
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.props.openUserUpdateModal();
        this.setState({ showEditFormModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showEditFormModal: false });
    }

    render() {
        const selectedSubPageLinkStyle = {
            color: this.props.themeColors.themeHoverColor,
            fontSize: '16px',
            fontWeight: 'bold',
        }
        const subPageLinkStyle = {
            color: this.props.themeColors.darkThemeColor,
            fontSize: '16px',
            fontWeight: 'bold',
        }
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }

        /// README: CHECK IF USER DATA IS NOT UNDEFINED 
        if (this.props.userData) {
            const { themeColors, userData, modalStyles, auth } = this.props;
            const { isUserUpdated } = auth;
            const { uid, name, email, phone, address, profilePic } = userData;

            return (
                <div className="container-fluid">
                    <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>
                        {/* EDIT MODAL */}
                        <ReactModal
                            style={modalStyles}
                            isOpen={this.state.showEditFormModal && !isUserUpdated === true}
                            onRequestClose={() => { this.handleCloseModal() }}
                            contentLabel="Add new tag"
                            ariaHideApp={false}
                        >
                            <button className="close" onClick={() => { this.handleCloseModal() }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <EditProfileForm />
                        </ReactModal>

                        {/* MAIN PROFILE CARD */}
                        <div className="">
                            <h5 className="card-header" >
                                <div className="d-flex justify-content-between">
                                    {/* NAME, EMAIL AND DP */}
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center" style={{ width: "200px" }}>
                                            <img src={profilePic ? profilePic : EmptyUserDefault} alt="user" className="avatar" style={{ width: "90px", height: "90px" }} />
                                        </div>
                                        <div className="align-self-center">
                                            <div className="d-flex flex-column">
                                                <div className="align-self-start"><h4><b>{name}</b></h4></div>
                                                <div className="align-self-start"><p style={{ fontSize: "17px" }}>{email}</p></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* PROFILE EDITING BUTTON */}
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center">
                                            <div className="d-flex flex-column">
                                                <div className="align-self-end">
                                                    <ProfileEditButton themeColors={themeColors}>
                                                        <button className="btn btn-default btn-sm" style={{borderRadius:'10px'}} onClick={this.handleOpenModal}>
                                                            <MDICONS.Edit /> {" "} Edit profile
                                                        </button>
                                                    </ProfileEditButton>
                                                </div>
                                                <div className="align-self-end">
                                                    <SignOutButton themeColors={themeColors}>
                                                        <button className="btn btn-default"  onClick={this.handleSignOut}>Sign out</button>
                                                    </SignOutButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </h5>
                            <div className="card-body">
                                <div className="d-flex justify-content-between">

                                    {/* DETAILS */}
                                    <div className="col-8 px-2">
                                        <div className="card m-1 py-4 px-2">
                                           
                                        </div>
                                    </div>

                                    {/* WORK HISTORY */}
                                    <div className="col-4 px-2">
                                        <div className="card m-1">
                                            <div className="card-body">
                                                <div>
                                                    <ul className="list-group align-items-start list-group-flush">
                                                        <li className="list-group-item">
                                                            <MDICONS.PhoneRounded /> {" " + phone}
                                                        </li>
                                                        <li className="list-group-item">
                                                            <MDICONS.MailRounded /> {" " + email}
                                                        </li>
                                                        <li className="list-group-item">
                                                            <MDICONS.WorkRounded /> {" " + address}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card m-1">
                                            <div className="card-body">
                                                <QRGenerate value={uid ?? ""} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="container-fluid">
                    <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '150px' }}>
                        <div className="card p-3 pt-5">
                            <Loader
                                type="TailSpin"
                                color={this.props.themeColors.themeColor}
                                height={50}
                                width={50}
                            />
                            <br></br>
                            <p style={textStyle}>Loading your profile...</p>
                            <br></br>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userId: state.firebase.auth.uid,
        userData: state.firebase.profile,
        modalStyles: state.appControl.modalStyles,
        auth: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => dispatch(signOut()),
        openUserUpdateModal: () => dispatch(openUserUpdateModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);